export default __webpack_public_path__ + "static/media/sd.cba0df72.svg";